export default class AuthorizationService {
  constructor(SessionsService) {
    'ngInject';
    this.SessionsService = SessionsService;
  }

  checkAuthenticated() {
    let promise;
    if (this.SessionsService.isStateCorrupt()) {
      promise = Promise.reject(['authError', 'redirect']);
    } else if (this.SessionsService.isLoggedIn()) {
      promise = Promise.resolve(true);
    } else {
      promise = Promise.resolve(true);//Promise.reject(['authError', 'sign_in']);
    }
    return promise;
  }

  checkNotAuthenticated() {
    let promise;
    if (this.SessionsService.isStateCorrupt()) {
      this._redirectToLogin();
    } else if (!this.SessionsService.isLoggedIn()) {
      promise = Promise.resolve(true);
    } else {
      promise = Promise.reject(['authError', 'home']);
    }
    return promise;
  }

  checkIsOrgAdmin() {
    let promise;
    if (this.SessionsService.isStateCorrupt()) {
      this._redirectToLogin();
    } else if (!this.SessionsService.isLoggedIn()) {
      promise = Promise.reject(['authError', 'sign_in']);
    } else if (!this.SessionsService.isAdminOrDistributorAdmin()) {
      promise = Promise.reject(['authError', 'home']);
    } else {
      promise = Promise.resolve(true);
    }
    return promise;
  }
}
